export default "__VITE_ASSET__b083052e__"